import { combineReducers } from "redux";
import createNamedWrapperReducer from "@redux/feature/Markets/Equity/wrapperReducer";
import PartnerNRDataReducer from "./reducer/PartnerNRSummaryReducer";
export default combineReducers({
    PartnerNRSummaryData: createNamedWrapperReducer(PartnerNRDataReducer, "PartnerNRSummaryData"),
});
